import { render, staticRenderFns } from "./KolSelectionRecord.vue?vue&type=template&id=d77ad5d4&scoped=true"
import script from "./KolSelectionRecord.vue?vue&type=script&lang=js"
export * from "./KolSelectionRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d77ad5d4",
  null
  
)

export default component.exports